import type { MappedProductVariant } from '@libs/algolia';
import type { OcapiProps } from '@libs/common-next';

export const hasCaseRequiredAndQuantity = (
    selectedProduct: MappedProductVariant
) =>
    !!(selectedProduct.isCaseRequiredSTH && selectedProduct.customCaseQuantity);

export const getBasketQuantity = (
    ocapi: OcapiProps | undefined,
    availableToSell: number,
    productId: string
) => {
    const onBasket = ocapi?.basket?.product_items?.find(
        productItem => productItem.product_id === productId
    );

    const onBasketQty = onBasket?.quantity ?? 0;
    return Math.max(availableToSell - onBasketQty, 0);
};
